// extracted by mini-css-extract-plugin
export var askAiIcon = "_q4-9";
export var container = "_q4-0";
export var groupSeparator = "_q4-a";
export var highlight = "_q4-4";
export var resultIcon = "_q4-5";
export var resultItem = "_q4-7";
export var resultSubtitle = "_q4-3";
export var resultTitle = "_q4-2";
export var resultsList = "_q4-1";
export var searchGroup = "_q4-6";
export var selected = "_q4-8";